import { IStaticAccordion } from "../../../../Contracts/StaticDataAccordion";
import { LegislationSections } from "../../../Model/Enum/BEE123Enums";

export const EELegislation: Array<IStaticAccordion> = [
    {
      title: "Employment Equity Act",
      groups: [
        {
          items: [
            {
              title: "Employment Equity Amendment Act 4 of 2022",
              link: "Employment Equity Amendment Act No4 of 2022_14 April 2023.pdf",
              section: LegislationSections.EmploymentEquityAct
            },
            {
              title: "Employment Equity Act (19 October 1998)",
              link: "Employment_Equity_Act_1998.pdf",
              section: LegislationSections.EmploymentEquityAct
            },
            {
              title: "Employment Equity Regulations (21 September 2018)",
              link: "Employment_Equity_Regulations_2018.pdf",
              section: LegislationSections.EmploymentEquityAct
            },
            {
              title: "Employment Equity Amendment Bill (21 September 2018)",
              link: "Employment_Equity_Amendment_Bill_2018.pdf",
              section: LegislationSections.EmploymentEquityAct
            },
            {
              title: "Employment Equity Act Gazetted (16 January 2014)",
              link: "Employment_Equity_Act_gazetted_on_the_16_January_2014.pdf",
              section: LegislationSections.EmploymentEquityAct
            },
            {
              title: "Draft Employment Equity Regulations 2023 for Public Comment (12 May 2023)",
              link: "Draft_Employment_Equity_Regulations_2023_for_Public_Comment_12_May_2023.pdf",
              section: LegislationSections.EmploymentEquityAct
            },
            {
              title: "Draft Regulations on proposed Sectoral Numerical Targets (1 Feb 2024)",
              link: "Draft_Regulations_on_proposed_Sectoral_Numerical_Targets_01022024.pdf",
              section: LegislationSections.EmploymentEquityAct
            },
          ],
        },
      ],
    },
    {
      title: "Codes of Good Practice",
      groups: [
        {
          items: [
            {
              title: "Code of Good Practice on the Handling of Sexual Harassment Cases in the Workplace (4 August 2005)",
              link: "Code_of_Good_Practice_on_the_Handling_of_Sexual_Harassment_Cases_in_the_Workplace.pdf",
              section: LegislationSections.CodesOfGoodPractice
            },
            {
              title: "Code of Good Practice on the Employment of Persons with Disabilities (9 November 2015)",
              link: "Code_of_Good_Practice_on_the_Employment_of_persons_with_disabilities_09_11_2015.pdf",
              section: LegislationSections.CodesOfGoodPractice
            },
            {
              title: "Code of Good Practice on Equal Pay/Remuneration for Work of Equal Value (1 June 2015)",
              link: "Code_of_Good_Practice2015_Equal_Pay.pdf",
              section: LegislationSections.CodesOfGoodPractice
            },
            {
              title: "Code of Good Prctice on HIV and AIDS and the World of Work (15 June 2012)",
              link: "Code_of_Good_Practice_on_HIV_AND_AIDS.pdf",
              section: LegislationSections.CodesOfGoodPractice

            },
            {
                title: "Code of Good Practice on the Preparation, Implementation and Monitoring of the EE Plan (12 May 2017)",
                link: "Code_of_Good_Practice_on_the_Preparation,_Implementation_and_Monitoring_of_EE_Plan.pdf",
                section: LegislationSections.CodesOfGoodPractice

            },
            {
              title: "Code of Good Practice on the Integration of Employment Equity into Human Resource Policies and Practices (4 August 2005)",
              link: "Code_of_Good_Practice_on_the_Integration_of_EE_into_Human_Resource_Policies_and_Practices.pdf",
              section: LegislationSections.CodesOfGoodPractice

            },
          ],
        },
      ],
    },
    {
      title: "Technical Assistance Guidelines",
      groups: [
        {
          items: [
            {
              title: "Technical Assistance Guidelines on the Employment of Person with Disabilities", 
              link: "Revised_TAG_for_persons_with_disabilities.pdf",
              section: LegislationSections.TechnicalAssistanceGuidelines
            },
            {
              title: "Technical Assistance Guidelines on HIV and Aids and the World of Work (2012)", 
              link: "EE_HIV_AIDS_TAG_2012.pdf",
              section: LegislationSections.TechnicalAssistanceGuidelines
            },
            {
              title: "Repeal of Employment Equity Regulations (1 August 2014)",
              link: "2014_EE_Regulations_published_on_1_August_2014.pdf",
              section: LegislationSections.TechnicalAssistanceGuidelines
            }
          ],
        },
      ],
    },
    {
      title: "Notices",
      groups: [
        {
          items: [
            {
              title: "Proclamation Notice 231 of 2024 - Commencement of the Employment Equity Act No 4 of 2022 (28 November 2024)", 
              link: "Proclamation_Notice_Commencement_of_Employment_Equity_Act.pdf",
              section: LegislationSections.Notices
            },
            {
              title: "Notice to All Employers regarding the 2023 EE Reporting Period", 
              link: "DoL_Notification_Reporting_Period.pdf",
              section: LegislationSections.Notices
            }
          ],
        },
      ],
    },
    {
      title: "Reports",
      groups: [
        {
          items: [
            {
              title: "24th Commission for Employment Equity Annual Report (26 June 2024)", 
              link: "24th Commission for Employment Equity Annual Report.pdf",
              section: LegislationSections.Reports
            },
            {
              title: "23rd Commission for Employment Equity Annual Report (23 June 2023)", 
              link: "23rd Annual CEE Report.pdf",
              section: LegislationSections.Reports
            },
            {
              title: "22nd Commission for Employment Equity Annual Report (23 June 2022)",
              link: "22nd CEE Annual Report.pdf",
              section: LegislationSections.Reports
            },
            {
              title: "21st Commission for Employment Equity Annual Report (25 June 2021)", 
              link: "21st CEE Report.pdf",
              section: LegislationSections.Reports
            },
            {
              title: "20th Commission for Employment Equity Annual Report (24 August 2020)", 
              link: "20th CEE Report.pdf",
              section: LegislationSections.Reports
            }
          ],
        },
      ],
    },    
    {
      title: "Other Relevant Acts",
      groups: [
        {
          items: [
            {
              title: "Basic Conditions of Employment Act 75 of 1997", 
              link: "Act - Basic Conditions of Employment.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Basic Conditions of Employment Amendment Act 11 of 2002", 
              link: "Amended Act - Basic Conditions of Employment.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Basic Conditions of Employment Act, Determination: Earnings Threshold 2024",
              link: "Basic Conditions of Employment Act Earnings Threshold 2024.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Labour Laws Amendment Act 10 of 2018", 
              link: "Labour Laws Amendment Act, 27 November 2018.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Labour Relations Act 66 of 1995", 
              link: "Labour Relations Act.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Labour Relations Amendment Act 8 of 2018", 
              link: "Labour Relations Amendment Act, 27 November 2018.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Labour Relations Amendment Act, Regulations 2018 (A - C)", 
              link: "Labour Relations Amendment Act, Regulations 2018 (A - C).pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Labour Relations Amendment Act, Regulations 2018 (D - E)", 
              link: "Labour Relations Amendment Act, Regulations 2018 (D - E).pdf",
              section: LegislationSections.OtherRelevantActs
            },            
            {
              title: "Compensation for Occupational Injuries and Diseases Amendment Act 130 of 1993", 
              link: "Amended Act - Compensation for Occupational Injuries and Diseases.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Compensation for Occupational Injuries and Diseases Amendment Act 61 of 1997", 
              link: "Amendment - Compensation for Occupational Injuries and Diseases 1997.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Compensation for Occupational Injuries and Diseases Amendment Act 10 of 2022",
              link: "Compensation for Occupational Injuries and Diseases Amendment Act 2022_ 17 April 2023.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Compensation for Occupational Injuries and Diseases Amendment of Schedule 3 (30 April 2004)", 
              link: "Amendment - COID - Schedule 3.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Occupational Health and Safety Act 85 of 1993", 
              link: "Occupational Health and Safety Act, 1993.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Occupational Health and Safety Amendment Act 181 of 1993", 
              link: "Amended Act - Occupational Health and Safety.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Skills Development Amendment Act 31 of 2003", 
              link: "Amended Act - Skills Development 2003.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Skills Development Amendment Act 37 of 2008", 
              link: "Skills Dev Act - 2008.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Skills Development Levies Act - 1999",
              link: "Act - Skills Development Levies-ammended.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Unemployment Insurance Contributions Act 4 of 2002", 
              link: "Amended Act - Unemployment Insurance Contributions.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Unemployment Insurance Amendment Act 10 of 2016", 
              link: "Unemployment Insurance Amendment Act 2016.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Promotion of Access to Information Act 2 of 2000", 
              link: "Promotion of access to information act 2000.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Employment Services Act 4 of 2014", 
              link: "Employment Services Act 2014.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Employment Tax Incentive Act 26 of 2013", 
              link: "Employment Tax Incentive Act 26 of 2013.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "National Minimum Wage Act 9 of 2018", 
              link: "National Minimum Wage Act No 9 of 2018.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "National Qualifications Framework Act 67 of 2008", 
              link: "National Qualifications Framework Act 67 of 2008.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "National Qualifications Framework Amendment Act 12 of 2019",
              link: "National Qualifications Framework Amendment Act 12 of 2019.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Occupational Diseases in Mines and Works Act 78 of 1973", 
              link: "Occupational Diseases in Mines and Works Act 78 of 1973.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Companies Act 71 of 2008", 
              link: "Companies-Act-2008.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Companies Act - Regulations 2023", 
              link: "Companies-amendment-regulations-2023.pdf",
              section: LegislationSections.OtherRelevantActs
            },            
            {
              title: "Income Tax Act 58 of 1962",
              link: "Income_Tax_Act-58-of-1962.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "South African Revenue Services Act 34 of 1997", 
              link: "South African Revenue Services Act 34 of 1997.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Tax Administration Act 28 of 2011", 
              link: "Tax Administration Act 28 of 2011.pdf",
              section: LegislationSections.OtherRelevantActs
            },
            {
              title: "Constitution of the Republic of South Africa 1996", 
              link: "Constitution of the Republic of South Africa 1996.pdf",
              section: LegislationSections.OtherRelevantActs
            },
          ],
        },
      ],
    }
  ];
  